import React from 'react';

export const BannerSection: React.FC = () => {
  return (
    <section className="relative h-96 flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/banners/hero-contact.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">Get in Touch</h1>
        <p className="text-xl md:text-2xl font-light max-w-2xl mx-auto">
          Ready to plan your next adventure? Our travel experts are here to help you create unforgettable memories
        </p>
      </div>
    </section>
  );
};